<template>
  <div>
    <!-- 富文本编辑器弹窗 -->
    <el-dialog
      title="编辑内容"
      width="600px"
      :visible="dialogShow"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <div class="editor-box">
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 350px"
          v-model="editorHtml"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditorDialog()">取 消</el-button>
        <el-button type="primary" @click="saveEditorContent()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import api from "../../../assets/js/api";
import axios from "@/assets/js/request";
import { Loading } from "element-ui";
export default {
  name: "ShopCenterAdminWebMEditorDialog",
  components: {
    Editor,
    Toolbar,
  },

  data() {
    return {
      editor: null,
      editorHtml: "", // 富文本内容
      toolbarConfig: {
        // 隐藏哪些菜单
        excludeKeys: [
          "code",
          "sup",
          "sub",
          "todo",
          "insertLink",
          "codeBlock",
          "group-video",
          "insertTable",
          "fullScreen",
          "insertImage",
          "numberedList",
          "bulletedList",
          "blockquote",
          "|",
        ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        // 选中内容时的悬浮菜单
        hoverbarKeys: {
          image: {
            // 清空 image 元素的 hoverbar
            menuKeys: [],
          },
          text: {
            // 清空 text 元素的 hoverbar
            menuKeys: [],
          },
        },
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          // const Message = this.$message;
          uploadImage: {
            // 自定义图片上传
            async customUpload(imgFile, insertFn) {
              // 限制为1mb
              if (imgFile.size > 1 * 1024 * 1024) {
                window.Message({
                  showClose: true,
                  message: "图片过大，请压缩后重新上传~",
                  type: "error",
                });
                return;
              }
              // 上传图片
              const formDate = new FormData();
              formDate.append("file", imgFile);
              // 开启loading
              const loading = Loading.service({
                lock: true,
                customClass: "loading",
              });
              // 不压缩直接进行上传
              const res = await axios.post(
                api.decoration.uploadEditorImage,
                formDate
              );
              if (res.result && res.result.success) {
                // 最后插入图片
                insertFn(res.result.filePath, "", "");
                // 关闭loading
                loading.close();
                window.Message({
                  message: "图片上传成功~",
                  type: "success",
                });
                return;
              } else {
                // 关闭loading
                loading.close();
                window.Message({
                  message: `图片上传失败，${res.error.message}`,
                  type: "error",
                });
                return;
              }
            },
          },
        },
      },
      mode: "default", // 编辑器模式
    };
  },
  computed: {
    dialogShow() {
      if (
        this.$store.state.mDecoration.dialogType == "tabEditor" ||
        this.$store.state.mDecoration.dialogType == "floorEditor"
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    dialogShow: {
      handler(newValue) {
        // 如果是显示tab导航的简介弹窗 则回显简介内容
        if (
          newValue &&
          this.$store.state.mDecoration.dialogType == "tabEditor"
        ) {
          this.editorHtml = this.$store.state.mDecoration.tabList.find(
            (item) => item.menuType == 5
          ).content;
        }
        // 如果是富文本楼层的编辑弹窗 则回显楼层内容
        if (
          newValue &&
          this.$store.state.mDecoration.dialogType == "floorEditor"
        ) {
          this.editorHtml = JSON.parse(
            JSON.stringify(this.$store.state.mDecoration.currentFloor)
          ).contentHtml;
          // this.editor.setHtml(
          //   this.$store.state.mDecoration.currentFloor.contentHtml
          // );
        }
      },
    },
  },
  mounted() {
    // 绑定message组件 用于富文本编辑器上传图片成功后的提示
    window.Message = this.$message;
  },

  methods: {
    // 富文本编辑器初始化事件
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 保存富文本编辑器内容
    async saveEditorContent() {
      // 进行风险词校验
      const res = await this.$axios.post(api.decoration.checktext, {
        text: this.editorHtml,
      });
      // 存在风险词
      if (res.result.conclusionType === 1) {
        let text = "";
        res.result.hits.forEach((item) => {
          item.detectionResult.forEach((item2) => {
            text += item2.keyword + "、";
          });
        });
        text = text.slice(0, text.length - 1);
        this.$message({
          message: `您输入的内容中存在以下风险词汇：${text}，请修改后再保存~`,
          type: "warning",
        });
        return;
      }
      // 如果是导航简介的富文本
      if (this.$store.state.mDecoration.dialogType == "tabEditor") {
        // 获取导航数据
        let tabList = JSON.parse(
          JSON.stringify(this.$store.state.mDecoration.tabList)
        );
        // 存储富文本
        tabList.forEach((item) => {
          if (item.menuType == 5) {
            item.content = this.editorHtml;
          }
        });
        // 将数据更新到对应的vuex中
        this.$store.commit("mDecoration/setTabList", tabList);
      }
      // 如果是富文本楼层的弹窗
      if (this.$store.state.mDecoration.dialogType == "floorEditor") {
        const list = JSON.parse(
          JSON.stringify(this.$store.state.mDecoration.floorList)
        );
        const index = list.findIndex(
          (item) => item.key == this.$store.state.mDecoration.currentFloor.key
        );
        list[index].contentHtml = this.editorHtml;
        this.$store.commit("mDecoration/setFloorList", list);
        const info = JSON.parse(
          JSON.stringify(this.$store.state.mDecoration.currentFloor)
        );
        info.contentHtml = this.editorHtml;
        this.$store.commit("mDecoration/setCurrentFloor", info);
      }
      this.closeEditorDialog();
    },
    // 关闭弹窗
    handleClose(done) {
      this.closeEditorDialog();
      done();
    },
    // 关闭弹窗操作
    closeEditorDialog() {
      // 清空富文本的值
      this.editorHtml = "";
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "");
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding-top: 0 !important;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 40px;
  }
}
</style>
